var _Fragment, _PreloadResources, _Fragment3, _Devtools;
/* eslint-disable @crehana/eslint-plugin/next/no-img-element */
import { CREHANA_BASE_URL_PRD } from '@crehana/constants';
import { Devtools, FacebookPixel, GoogleScripts, PreconnectResources, PreloadResources } from "./_components";
import { addMicrofrontendNameToWindows } from "./_utils";
import { AppRouterRoot } from "./root";
import { jsx as _jsx, Fragment as _Fragment2, jsxs as _jsxs } from "react/jsx-runtime";
addMicrofrontendNameToWindows();
var isQaOrProdEnv = process.env.APP_ENV === 'production' || process.env.APP_ENV === 'qa';
export var RootLayout = function RootLayout(_ref) {
  var children = _ref.children,
    countryCode = _ref.countryCode,
    languageCode = _ref.languageCode,
    _ref$authProvider = _ref.authProvider,
    authProvider = _ref$authProvider === void 0 ? true : _ref$authProvider;
  return /*#__PURE__*/_jsxs("html", {
    lang: languageCode || 'es',
    children: [/*#__PURE__*/_jsxs("head", {
      children: [isQaOrProdEnv && (_Fragment || (_Fragment = /*#__PURE__*/_jsxs(_Fragment2, {
        children: [/*#__PURE__*/_jsx(PreconnectResources, {}), /*#__PURE__*/_jsx("link", {
          rel: "search",
          type: "application/opensearchdescription+xml",
          title: "Crehana Search",
          href: "/opensearch.xml"
        })]
      }))), isQaOrProdEnv ? _PreloadResources || (_PreloadResources = /*#__PURE__*/_jsx(PreloadResources, {})) : null, isQaOrProdEnv ? /*#__PURE__*/_jsx("link", {
        rel: "manifest",
        href: "".concat(CREHANA_BASE_URL_PRD, "/manifest.json")
      }) : null]
    }), /*#__PURE__*/_jsxs("body", {
      children: [isQaOrProdEnv ? /*#__PURE__*/_jsxs(_Fragment2, {
        children: [/*#__PURE__*/_jsx("noscript", {
          children: /*#__PURE__*/_jsx("iframe", {
            src: "https://www.googletagmanager.com/ns.html?id=".concat(process.env.NEXT_PUBLIC_GTM_ID),
            height: "0",
            width: "0",
            style: {
              display: 'none',
              visibility: 'hidden'
            }
          })
        }), /*#__PURE__*/_jsx("noscript", {
          children: /*#__PURE__*/_jsx("img", {
            alt: "noscript-fbpixel",
            height: "1",
            width: "1",
            style: {
              display: 'none'
            },
            src: "https://www.facebook.com/tr?id=".concat(process.env.NEXT_PUBLIC_FB_PIXEL_ID, "&ev=PageView&noscript=1")
          })
        })]
      }) : null, /*#__PURE__*/_jsx("span", {
        className: "cui-is-visible cui-is-hidden",
        style: {
          opacity: 0,
          visibility: 'hidden',
          height: 0,
          width: 0,
          position: 'absolute'
        },
        "aria-hidden": true
      }), /*#__PURE__*/_jsx(AppRouterRoot, {
        countryCode: countryCode,
        languageCode: languageCode,
        authProvider: authProvider,
        children: children
      }), isQaOrProdEnv && (_Fragment3 || (_Fragment3 = /*#__PURE__*/_jsxs(_Fragment2, {
        children: [/*#__PURE__*/_jsx(FacebookPixel, {}), /*#__PURE__*/_jsx(GoogleScripts, {})]
      }))), _Devtools || (_Devtools = /*#__PURE__*/_jsx(Devtools, {}))]
    })]
  });
};